import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ILogin } from './login';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Globals } from 'src/app/_utlity/globals';
import { GlobalService } from 'src/app/_services/CommonServices/global.service';
import { loginInfo, Mail, SAPID } from 'src/app/_shared/common/global-variables';
import { UtilityCryptoService } from 'src/app/_services/ApplicationServices/utility-crypto.service';
import { ClearText,CipherText } from 'src/app/_shared/common/global-variables';
import { MsalService } from '@azure/msal-angular';
//import { ConsoleReporter } from 'jasmine';


@Injectable({
  providedIn: 'root'
})
export class LoginService implements OnInit {
  private getEmployeeInfoUrl = "DashBoard/GetEmployeeInfo";
  private checkAccessURL = "DashBoard/GetRollBasedDataForMenuItems";
  private checkEmpSapId = "Dashboard/GetEmpSAPID";
  //private getAuthInfo = "DashBoard/GetEmpLoggedinInfo"; //this not AD Auth
  private getUserProfile = "DashBoard/GetUserProfile"; // With AD
  isloginPage = false;
  isEncrypted = false;
  isRefreshed = false;
  constructor(private authService: MsalService, private http: HttpClient, private globals: Globals, private globalServices: GlobalService) { }
  ngOnInit(): void {
  }

  getEmployeeId(): Observable<loginInfo> {
    const emailId = <Mail>
      {
        EmailId: localStorage.getItem("UserName")
      }
    const httpHeaders = new HttpHeaders({
      'Access-Control-Allow-Origin': 'Access-Control-Allow-Origin',  //QA   
    });
    return this.http.post<loginInfo>(this.globalServices.baseUrl + this.checkEmpSapId, emailId, { headers: httpHeaders })
  }


  getEmployeeInfo(SapId: string): Observable<any> {
    //console.log("empId", SapId)
    const sapId = <SAPID>{
      ReqSAPID: SapId
    }
    //console.log("reqsapid", sapId)
    const httpHeaders = new HttpHeaders({
      'Access-Control-Allow-Origin': 'Access-Control-Allow-Origin'
    });
    return this.http.post<any>(this.globalServices.baseUrl + this.getEmployeeInfoUrl, sapId, { headers: httpHeaders })
      .pipe(retry(1),
        catchError(this.handleError));
  }

  getAuthenticationInfo(sapid: string): Observable<any> {
    const sapId = <SAPID>{
      ReqSAPID: sapid
    }
    const httpHeaders = new HttpHeaders({
      'Access-Control-Allow-Origin':'Access-Control-Allow-Origin',  //QA
    });
    return this.http.post<any>(this.globalServices.baseUrl + this.getUserProfile, sapId, { headers: httpHeaders })
  }

  private handleError(err: HttpErrorResponse) {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred : ${err.error.message}`;
    }
    else {
      errorMessage = `Server returned code: ${err.status}, errorMessage is : ${err.message}`;
    }
    //console.error(errorMessage);
    return throwError(errorMessage);
  }

  checkAccessOfDelegationReportmenu(EmpId: string): Observable<any> {
    EmpId = this.globalServices.UserLoggedInSAPID;
    const sapId = <SAPID>{
      ReqSAPID: EmpId
    }
    const httpHeaders = new HttpHeaders({
      'Access-Control-Allow-Origin': 'Access-Control-Allow-Origin',  //QA
    });
    return this.http.post<any>(this.globalServices.baseUrl + this.checkAccessURL, sapId, { headers: httpHeaders });
  }

  encValues: string = '';
  url: string;
  encSapId: string = '';
  encAppId: string = '';
  getEncryptValues(Values: string): string {
    this.pullEncryptValue(Values).subscribe(
      res => {

        //console.log(res[0].ClearText);
        this.encValues = res[0].ClearText;
      }
    )
    this.isEncrypted = true;
    return this.encValues;
  }

  private encryptUrl = "Application/EncryptCode";
  pullEncryptValue(Value: string): Observable<any> {
    const ClearText = <ClearText>
      {
        ClearText: Value
      }
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json',
      });

    return this.http.post<any>(this.globalServices.baseUrl + this.encryptUrl, ClearText, { headers: httpHeaders });
  }

  private decryptUrl = "Application/DecryptCode";
  GetDecryptCodeValue(Value: string): Observable<any> {
    const CipherText = <CipherText>
      {
        CipherText: Value
      }
    const httpHeaders = new HttpHeaders(
      {
        'Content-Type': 'application/json',
      });

    return this.http.post<any>(this.globalServices.baseUrl + this.decryptUrl, CipherText, { headers: httpHeaders });
  }

  getToken() {
    const param = {
      scopes: ["api://3ae19be7-a3d1-4b57-a806-4e4809998d47/access_as_user"],
    }
    if (!sessionStorage.getItem('AccessToken')) {
      this.ngOnInit();
    }
    else {
      this.authService.acquireTokenPopup(param).toPromise().then(function (response) {

        //console.log(response.accessToken);
        let accessToken = response.accessToken;
        sessionStorage.setItem('AccessToken', response.accessToken);

      })
    }
  }

}

